import React, { Component } from 'react';
import { ReactComponent as AddIcon } from "Icons/new-plus.svg";
import { ReactComponent as DeleteIcon } from "Icons/new-delete.svg";
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import Cx from 'classnames';

const CHARGES_TYPES = [
    { name: 'Warehouse Charges', value: 1 },
    { name: 'Handling Charges', value: 2 }
];

const APPLICABLE_TYPES = [
    {name: 'Applicable', value: true},
    {name: 'Not-Applicable', value: false}
]

const GST_APPLICABLE_TYPES = [
    {name: 'Yes', value: true},
    {name: 'No', value: false}
]


class CFAContract extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    renderTripsOrSearchedTrips=()=>{
        const { trips,searchText,searchedSecondaryCotractRfqTrips} = this.props;
        if(!!searchText){
            return searchedSecondaryCotractRfqTrips;
        }
        return trips;   
    }

    render() {
        const { cfaDetails, trips, onChangeTrips, isView,isEdit,searchText,searchedSecondaryCotractRfqTrips } = this.props;
        var symbolsArr = ["e", "E", "+", "-", "."];

        return (
            <>
                <input placeholder={"Search Trips"} 
                            type="text" 
                            className="mr-30 wt-200 br-20 ht-40 bg-gray search"
                            value={searchText}
                            onChange={this.props.onSearchTrip}
                        />
                <div className={Cx('mt-20 ht-90 pv-20 ph-20 bg-white br-5 lcl-contract-trips', {
                    'disable-pointer-events': isView
                })} style={{'border': '1px solid #85919E'}}>
                    <div className='content-bgColor pv-20 ph-10 mt-5 br-2 col-1 pb-50'>
                        <table className='trip-table-secondary' cellspacing={'10px'}>
                            <tr>
                                <th>Location</th>
                                <th>Type of Charges</th>
                                <th>Monthly Amount</th>
                                <th>GST Applicability</th>
                                <th>GST %</th>
                                {!isView && <th></th>}
                            </tr>
                            {(this.renderTripsOrSearchedTrips() || []).map((trip, tripIndex) => {
                                const tripId = trip.trip_id;
                            return(<tr>
                                <td>
                                    <Dropdown 
                                        items={cfaDetails}
                                        displayKey={"city"}
                                        className="border-dblue bg-white"
                                        name="from" 
                                        label="Select"
                                        selectedItem={(trip.stops[0] || {}).city && cfaDetails.find(el => el.city == (trip.stops[0] || {}).city)}
                                        onSelect={(optionValue) => {
                                            onChangeTrips(tripIndex, 'from', cfaDetails.find(el => el.city == optionValue));                                        
                                        }}
                                    />
                                </td>
                                <td>
                                    <Dropdown 
                                        items={CHARGES_TYPES}
                                        displayKey={"name"}
                                        className="border-dblue bg-white"
                                        name="from" 
                                        label="Select"
                                        selectedItem={trip.type_of_charges && CHARGES_TYPES.find(el => el.name == trip.type_of_charges)}
                                        onSelect={(optionValue) => {
                                            onChangeTrips(tripIndex, 'type_of_charges', optionValue);
                                        }}
                                    />
                                </td>
                                <td>
                                    <Dropdown 
                                        items={APPLICABLE_TYPES}
                                        displayKey={"name"}
                                        className="border-dblue bg-white"
                                        name="from" 
                                        label="Select"
                                        selectedItem={trip.monthly_amount && APPLICABLE_TYPES.find(el => el.name == trip.monthly_amount)}
                                        onSelect={(optionValue) => {
                                            onChangeTrips(tripIndex, 'monthly_amount', optionValue);
                                        }}
                                    />
                                </td>
                                <td>
                                    <Dropdown 
                                        items={GST_APPLICABLE_TYPES}
                                        displayKey={"name"}
                                        className="border-dblue bg-white"
                                        name="from" 
                                        label="Select"
                                        selectedItem={trip.gst_applicability && GST_APPLICABLE_TYPES.find(el => el.name == trip.gst_applicability)}
                                        onSelect={(optionValue) => {
                                            onChangeTrips(tripIndex, 'gst_applicability', optionValue);
                                        }}
                                    />
                                </td>
                                <td>
                                    <Input  
                                        className={'border-dblue br-2 wt-80 mr-5'}
                                        type={'number'}
                                        placeholder={'GST'}
                                        value={trip.gst_percentage}
                                        onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                        onChange={(e) => onChangeTrips(tripIndex, 'gst_percentage', e)}
                                    />
                                </td>
                                {!isView && <td>
                                    <div className='flex'>
                                        {!isEdit && trips.length > 1 && <DeleteIcon className='mr-5 ml-5 curP' onClick={() => this.props.onDeleteTrip(tripIndex)}/>}
                                        {isEdit && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => this.props.onEditDeleteTrip(tripId,tripIndex)}/>}
                                        <AddIcon  className="curP" onClick={() => this.props.onAddTrip()}/>
                                    </div>
                                </td>}
                            </tr>)})}
                        </table>
                    </div>
                </div>
            </>
        )
    }
}

export default CFAContract;